import { render, staticRenderFns } from "./address-autocomplete.vue?vue&type=template&id=28558330"
import script from "./address-autocomplete.vue?vue&type=script&lang=js"
export * from "./address-autocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports